import { Link, Typography } from '@mui/material';
import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import { useTranslation } from 'react-i18next';
import ReportFieldsDrawer from './report-fields-drawer.component';
import { ReportFieldsTab } from './report-fields.content';

export type ReportFieldsLinkProps = {
  tab: ReportFieldsTab;
};

/**
 * "Learn more about these Report Fields" row rendered under each Guest
 * Journey tab's toolbar; opens the per-tab glossary drawer.
 */
const ReportFieldsLink = ({ tab }: ReportFieldsLinkProps) => {
  const { t } = useTranslation();
  const drawer = useDrawer();

  return (
    <>
      <Typography
        variant="body2"
        color="text.secondary"
        textAlign="right"
        data-testid="ReportFieldsLink"
      >
        {t('page.guestJourney.reportFields.learnMorePrefix')}{' '}
        <Link
          component="button"
          type="button"
          onClick={() => drawer.open()}
          sx={{ verticalAlign: 'baseline' }}
          data-testid="ReportFieldsLink.Button"
        >
          {t('page.guestJourney.reportFields.linkText')}
        </Link>
      </Typography>
      <ReportFieldsDrawer {...drawer} tab={tab} />
    </>
  );
};

export default ReportFieldsLink;
